import { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  getNextPaymentDate,
  getPaymentAmount,
  getPaymentFrequencyMonths,
  getPaymentFrequencyDays,
  getPaymentFrequencyText,
  getStatus,
} from 'features/User/selectors';
import { setCancellationStep } from 'features/User/slice';

export const useProfileManageSubscriptionService = () => {
  const paymentFrequencyMonths = useSelector(getPaymentFrequencyMonths);
  const paymentFrequencyDays = useSelector(getPaymentFrequencyDays);
  const paymentFrequencyText = useSelector(getPaymentFrequencyText);
  const paymentAmount = useSelector(getPaymentAmount);
  const nextPaymentDate = useSelector(getNextPaymentDate);
  const status = useSelector(getStatus);

  const dispatch = useDispatch();

  const plan = useMemo(() => {
    if (paymentFrequencyDays !== null) {
      return `${paymentFrequencyText} plan`;
    }
    return `${paymentFrequencyMonths} month plan`;
  }, [paymentFrequencyMonths, paymentFrequencyDays, paymentFrequencyText]);

  const paymentAmountPerFrequencyMonth = useMemo(() => {
    switch (nextPaymentDate) {
      case 'Invalid date':
      case '': {
        return ' ';
      }
      default: {
        if (paymentFrequencyDays !== null) {
          return `${paymentAmount} ${paymentFrequencyText.toLowerCase()}`;
        }
        return `${paymentAmount}/${paymentFrequencyMonths} month`;
      }
    }
  }, [paymentFrequencyMonths, paymentFrequencyDays, paymentFrequencyText, paymentAmount, nextPaymentDate]);

  const nextBillingDate = useMemo(() => {
    switch (nextPaymentDate) {
      case '':
      case 'Invalid date': {
        return '';
      }
      default: {
        return `Next billing ${nextPaymentDate}`;
      }
    }
  }, [nextPaymentDate]);

  const canCancel = useMemo(
    () => status !== 'non_renewing' && !!nextBillingDate,
    [nextBillingDate, status]
  );

  const handleCancelPlan = useCallback(() => dispatch(setCancellationStep('prompt')), [dispatch]);

  return {
    canCancel,
    plan,
    nextBillingDate,
    paymentAmountPerFrequencyMonth,
    handleCancelPlan,
  };
};
